import React from "react";

type Props = {
  isActive: boolean;
  onPress?: (state: boolean) => void;
  isDisabled?: boolean;
  darkMode?: boolean;
};

function RadioButton({
  isActive,
  isDisabled = false,
  onPress,
  darkMode = false,
}: Props) {
  const handleClick = () => {
    if (onPress && !isDisabled) {
      onPress(!isActive);
    }
  };

  return (
    <div
      className={`w-[18px] h-[18px] rounded-full border-2 flex items-center justify-center ${
        isDisabled
          ? "border-grey-light"
          : darkMode
          ? "border-purple-500"
          : "border-[#6424C5]"
      } mt-[2px]`}
      onClick={handleClick}
    >
      <div
        className={`w-[11px] h-[11px] rounded-full ${
          isActive
            ? darkMode
              ? "bg-purple-500"
              : "bg-gradient-brand-dark"
            : darkMode
            ? "bg-transparent"
            : "bg-white"
        } `}
      />
    </div>
  );
}

export default RadioButton;
